import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { getCurrentLanguage, decimalRegex } from '@/utils'
import en from '@/locales/en.json'
import ru from '@/locales/ru.json'

import { extend } from 'vee-validate'
import { required, integer, max, regex } from 'vee-validate/dist/rules'

Vue.use(VueI18n)

const messages = { en, ru }
const locale = getCurrentLanguage()

const i18n = new VueI18n({
  locale: locale,
  fallbackLocale: 'ru',
  messages
})

extend('required', {
  ...required,
  message: (_, values) => i18n.t('formErrors.fieldRequired', values)
})

extend('integer', {
  ...integer,
  message: (_, values) => i18n.t('formErrors.mustBeNumber', values)
})

extend('max', {
  ...max,
  message: (field, values) => i18n.t(`formErrors.${field}Max${values.length}Char`, values)
})

extend('regex', {
  ...regex,
  message: (_, values) => {
    switch (String(values.regex)) {
      case String(decimalRegex):
        return i18n.t('formErrors.mustBeNumber', values)

      default:
        return `Must match the following regex: ${values.regex}`
    }
  }
})

export default i18n
